<template>
  <div
    v-if="status && status.state !== 'ready'"
    class="editor-data-status"
    :role="status.state === 'error' ? 'alert' : 'status'"
  >
    <template v-if="status.state === 'loading'">
      <i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
      Carregando {{ label }}...
    </template>
    <template v-else>
      Não foi possível carregar {{ label }}.
      <button type="button" @click.stop="$emit('retry')">
        Tentar novamente
      </button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    status: { type: Object, default: null },
    label: { type: String, default: "opções" }
  }
};
</script>

<style scoped>
.editor-data-status {
  align-items: center;
  color: #766d82;
  display: flex;
  flex-wrap: wrap;
  font-size: calc(11px * var(--rete-card-text-scale, 1));
  gap: 6px;
  padding: 8px;
}
.editor-data-status button {
  background: transparent;
  border: 0;
  color: #462181;
  cursor: pointer;
  font: inherit;
  padding: 2px;
  text-decoration: underline;
}
</style>
